import { MDBCol, MDBRow } from 'mdbreact';
import React from 'react';
import { MDBMask, MDBView } from 'mdbreact';
import { Typography } from '@material-ui/core';

class ColourImage extends React.Component {

    render() {
        return (
                <MDBRow>
                    <MDBCol md="12">
                        <MDBView>
                            <img 
                                src={this.props.image} 
                                alt=""
                                style={{width:"100%"}}/>
                            <MDBMask className="flex-center" overlay={this.props.overlay}>
                                <Typography fontWeight='fontWeightBold' variant="h1" className="white-text" style={{fontSize:'2.5rem'}}>{this.props.text}</Typography>
                            </MDBMask>
                        </MDBView>
                    </MDBCol>
                </MDBRow>
        )
    }
}

export default ColourImage;